<form [formGroup]="formGroup">
  <mat-form-field class="select-option-chip">
    <mat-label>{{ label }}</mat-label>
    <mat-select
      #selectOption
      [placeholder]="placeholder"
      multiple
      id="optionchip"
      formControlName="value"
      (selectionChange)="onChange() ? selectOption.toggle() : null"
      [compareWith]="compareFn"
      [required]="getRequired()"
    >
      <mat-select-trigger>
        <mat-chip-listbox>
          @for (item of formGroup.get('value').value; track item) {
          <mat-chip-option
            [selectable]="false"
            [removable]="true"
            (removed)="removeItem(item)"
            color="primary"
          >
            {{ item.displayname }}
            @if (item && item.highlight) {
            <span class="highlight"> {{ item.highlight }}</span>
            }
            <mat-icon svgIcon="cancel" matChipRemove></mat-icon>
          </mat-chip-option>
          }
        </mat-chip-listbox>
      </mat-select-trigger>
      @for (item of getDataSource(); track item) {
      <mat-option [value]="item" [disabled]="item.disabled">
        {{ item.displayname }}
        @if (item && item.highlight) {
        <span class="highlight">{{ item.highlight }}</span>
        }
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>
